import { render, staticRenderFns } from "./BadgeOfGodnessCard.vue?vue&type=template&id=a61d2eea&scoped=true&"
import script from "./BadgeOfGodnessCard.vue?vue&type=script&lang=js&"
export * from "./BadgeOfGodnessCard.vue?vue&type=script&lang=js&"
import style0 from "./BadgeOfGodnessCard.vue?vue&type=style&index=0&id=a61d2eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61d2eea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VImg,VRow})
